const GAS = "gas";
const AUTO = "auto";
const FOOD = "food";
const HEARING = "hearing";
const OPTICAL = "optical";
const PHARMACY = "pharmacy";
const CARWASH = "carwash";
const getBaseBDWarehouseValue = (warehouseValue, addrType) => {
  let warehouseNumber = warehouseValue;
  if (addrType === "R") {
    warehouseNumber = warehouseNumber.replace("-ND", "");
  } else if (addrType === "S") {
    warehouseNumber = warehouseNumber.replace(/^(100|10)/, "");
  }
  return warehouseNumber;
};
const getWarehouseHours = (warehouse, title) => {
  var _a;
  try {
    return (_a = warehouse.hours) == null ? void 0 : _a.find((hour) => hour.title[0].value === title);
  } catch {
    return {
      close: "00:00:00",
      open: "00:00:00"
    };
  }
};
const getTimeZone = (warehouse) => {
  return warehouse.timeZone;
};
const findNextWorkingDay = (warehouse, givenDate) => {
  let nextWorkingDay = new Date(givenDate);
  nextWorkingDay.setDate(nextWorkingDay.getDate() + 1);
  if (isHoliday(warehouse, nextWorkingDay)) {
    nextWorkingDay = findNextWorkingDay(warehouse, nextWorkingDay);
  }
  return nextWorkingDay;
};
const nextOpenDate = (warehouse, todayDate) => {
  const tomorrowDate = new Date(todayDate);
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  if (isHoliday(warehouse, tomorrowDate)) {
    const nextWorkingDay = findNextWorkingDay(warehouse, todayDate);
    return nextWorkingDay;
  }
  return tomorrowDate;
};
const isHoliday = (warehouse, dateToCompare) => {
  var _a;
  const dd = String(dateToCompare.getDate()).padStart(2, "0");
  const mm = String(dateToCompare.getMonth() + 1).padStart(2, "0");
  const yyyy = dateToCompare.getFullYear();
  const todayString = `${yyyy}-${mm}-${dd}`;
  if ((_a = warehouse.holidays) == null ? void 0 : _a.find(
    (holiday) => {
      var _a2;
      return holiday.holidayDate === todayString && ((_a2 = holiday.holidayHoursType) == null ? void 0 : _a2.code) === "closed";
    }
  )) {
    return true;
  }
  return false;
};
const getDateString = (dateToday) => {
  const dd = String(dateToday.getDate()).padStart(2, "0");
  const mm = String(dateToday.getMonth() + 1).padStart(2, "0");
  const yyyy = dateToday.getFullYear();
  const todayString = `${yyyy}-${mm}-${dd}`;
  return todayString;
};
const formatLng = (lng) => {
  if (lng && lng.includes("-")) {
    const temp = lng.split("-");
    temp[1] = temp[1].toUpperCase();
    return temp.join("");
  }
  return lng;
};
const formatTime = (time, locale = "en-us", removeZeroMinutes = false, removeSpaceBeforePeriod = false) => {
  if (time) {
    const [hours, minutes] = time.split(":").map(Number);
    const date = /* @__PURE__ */ new Date();
    date.setHours(hours, minutes, 0, 0);
    if (locale === "fr-ca") {
      const formatter2 = new Intl.DateTimeFormat(locale, {
        hour: "numeric",
        hour12: false,
        minute: minutes !== 0 ? "2-digit" : void 0
      });
      return formatter2.format(date);
    }
    const formatter = new Intl.DateTimeFormat(locale, {
      hour: "numeric",
      hour12: true,
      minute: minutes !== 0 || !removeZeroMinutes ? "2-digit" : void 0
    });
    let formatted = formatter.format(date).replace(/(am|pm)/i, hours >= 12 ? "PM" : "AM");
    if (removeSpaceBeforePeriod) {
      formatted = formatted.replace(" ", "");
    }
    return formatted;
  }
  return time;
};
const convertTo12HourFormat = (timeString) => {
  const [hours, minutes, seconds] = timeString.split(":");
  const dateObj = /* @__PURE__ */ new Date();
  dateObj.setHours(parseInt(hours, 10));
  dateObj.setMinutes(parseInt(minutes, 10));
  dateObj.setSeconds(parseInt(seconds, 10));
  return dateObj.toLocaleTimeString([], {
    hour: "numeric",
    hour12: true,
    minute: "2-digit"
  });
};
const getDirections = (warehouse) => {
  try {
    const warehouseAddress = encodeURIComponent(
      ["Costco"].concat(warehouse == null ? void 0 : warehouse.address.line1.split(" ")).concat(warehouse == null ? void 0 : warehouse.address.city.split(" ")).concat(warehouse == null ? void 0 : warehouse.address.territory.split(" ")).concat(warehouse == null ? void 0 : warehouse.address.countryName.split(" ")).join(" ")
    );
    let protocol = "https";
    if (typeof window !== "undefined") {
      protocol = window.location.protocol;
    }
    return `${protocol}//maps.google.com?saddr=Current+Location&daddr=${warehouseAddress}`;
  } catch (err) {
    console.error(`Error in getDirections: ${err}`);
    return;
  }
};
const hasPremiumGasPrice = (warehouse) => {
  var _a, _b;
  return ((_a = warehouse == null ? void 0 : warehouse.gasPrices) == null ? void 0 : _a.premium) !== null && ((_b = warehouse == null ? void 0 : warehouse.gasPrices) == null ? void 0 : _b.premium) !== void 0;
};
const hasRegularGasPrice = (warehouse) => {
  var _a, _b;
  return ((_a = warehouse == null ? void 0 : warehouse.gasPrices) == null ? void 0 : _a.regular) !== null && ((_b = warehouse == null ? void 0 : warehouse.gasPrices) == null ? void 0 : _b.regular) !== void 0;
};
const hasDieselGasPrice = (warehouse) => {
  var _a, _b;
  return ((_a = warehouse == null ? void 0 : warehouse.gasPrices) == null ? void 0 : _a.diesel) !== null && ((_b = warehouse == null ? void 0 : warehouse.gasPrices) == null ? void 0 : _b.diesel) !== void 0;
};
const hasZeroEthanolGasPrice = (warehouse) => {
  var _a, _b;
  return ((_a = warehouse == null ? void 0 : warehouse.gasPrices) == null ? void 0 : _a.clear) !== null && ((_b = warehouse == null ? void 0 : warehouse.gasPrices) == null ? void 0 : _b.clear) !== void 0;
};
const hasSupportedServices = (warehouse) => {
  return hasGas(warehouse) || hasCarWash(warehouse) || hasTires(warehouse) || hasBusiness(warehouse) || hasFood(warehouse) || hasHearing(warehouse) || hasOptical(warehouse) || hasPharmacy(warehouse);
};
const hasGas = (warehouse) => {
  var _a;
  return (_a = warehouse == null ? void 0 : warehouse.services) == null ? void 0 : _a.some((service) => service.code === GAS);
};
const hasCarWash = (warehouse) => {
  var _a;
  return (_a = warehouse == null ? void 0 : warehouse.services) == null ? void 0 : _a.some((service) => service.code === CARWASH);
};
const hasTires = (warehouse) => {
  var _a;
  return (_a = warehouse == null ? void 0 : warehouse.services) == null ? void 0 : _a.some((service) => service.code === AUTO);
};
const hasFood = (warehouse) => {
  var _a;
  return (_a = warehouse == null ? void 0 : warehouse.services) == null ? void 0 : _a.some((service) => service.code === FOOD);
};
const hasHearing = (warehouse) => {
  var _a;
  return (_a = warehouse == null ? void 0 : warehouse.services) == null ? void 0 : _a.some((service) => service.code === HEARING);
};
const hasOptical = (warehouse) => {
  var _a;
  return (_a = warehouse == null ? void 0 : warehouse.services) == null ? void 0 : _a.some((service) => service.code === OPTICAL);
};
const hasPharmacy = (warehouse) => {
  var _a;
  return (_a = warehouse == null ? void 0 : warehouse.services) == null ? void 0 : _a.some((service) => service.code === PHARMACY);
};
const hasBusiness = (warehouse) => {
  var _a;
  return ((_a = warehouse == null ? void 0 : warehouse.subType) == null ? void 0 : _a.code) === "Business Center";
};
const milesToKm = (miles) => {
  return (miles * 1.60934).toFixed(2);
};
const capitalizeFirstLetter = (string) => {
  return (string == null ? void 0 : string.toLowerCase().charAt(0).toUpperCase()) + (string == null ? void 0 : string.slice(1).toLowerCase());
};
const getWarehouseName = (warehouse) => {
  var _a, _b;
  if ((_a = warehouse == null ? void 0 : warehouse.name[0]) == null ? void 0 : _a.value) {
    return (_b = warehouse == null ? void 0 : warehouse.name[0]) == null ? void 0 : _b.value;
  }
  return "";
};
const getWarehouseState = (warehouse) => {
  return warehouse == null ? void 0 : warehouse.address.territory;
};
const getWarehouseId = (warehouse) => {
  return warehouse == null ? void 0 : warehouse.warehouseId;
};
const getSlug = (warehouse) => {
  var _a;
  return `${getWarehouseName(warehouse).replace(/\s+/g, "-").toLowerCase()}-${(_a = getWarehouseState(
    warehouse
  )) == null ? void 0 : _a.toLowerCase()}-${getWarehouseId(warehouse)}`;
};
const utf8Decode = (utftext) => {
  let string = "";
  let i = 0;
  let c2, c3;
  let c = c2 = 0;
  while (i < utftext.length) {
    c = utftext.charCodeAt(i);
    if (c < 128) {
      string += String.fromCharCode(c);
      i++;
    } else if (c > 191 && c < 224) {
      c2 = utftext.charCodeAt(i + 1);
      string += String.fromCharCode((c & 31) << 6 | c2 & 63);
      i += 2;
    } else {
      c2 = utftext.charCodeAt(i + 1);
      c3 = utftext.charCodeAt(i + 2);
      string += String.fromCharCode(
        (c & 15) << 12 | (c2 & 63) << 6 | c3 & 63
      );
      i += 3;
    }
  }
  return string;
};
const decodeSurchargeCookie = (cookie) => {
  const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let output;
  let chr1, chr2, chr3;
  let enc1, enc2, enc3, enc4;
  let i = 0;
  cookie = cookie.replace(/[^A-Za-z0-9+/=]/g, "");
  while (i < cookie.length) {
    enc1 = keyStr.indexOf(cookie.charAt(i++));
    enc2 = keyStr.indexOf(cookie.charAt(i++));
    enc3 = keyStr.indexOf(cookie.charAt(i++));
    enc4 = keyStr.indexOf(cookie.charAt(i++));
    chr1 = enc1 << 2 | enc2 >> 4;
    chr2 = (enc2 & 15) << 4 | enc3 >> 2;
    chr3 = (enc3 & 3) << 6 | enc4;
    output = output + String.fromCharCode(chr1);
    if (enc3 !== 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 !== 64) {
      output = output + String.fromCharCode(chr3);
    }
  }
  output = utf8Decode(output == null ? void 0 : output.replace("undefined", ""));
  return JSON.parse(output);
};
export {
  capitalizeFirstLetter,
  convertTo12HourFormat,
  decodeSurchargeCookie,
  findNextWorkingDay,
  formatLng,
  formatTime,
  getBaseBDWarehouseValue,
  getDateString,
  getDirections,
  getSlug,
  getTimeZone,
  getWarehouseHours,
  getWarehouseId,
  getWarehouseName,
  getWarehouseState,
  hasBusiness,
  hasCarWash,
  hasDieselGasPrice,
  hasFood,
  hasGas,
  hasHearing,
  hasOptical,
  hasPharmacy,
  hasPremiumGasPrice,
  hasRegularGasPrice,
  hasSupportedServices,
  hasTires,
  hasZeroEthanolGasPrice,
  isHoliday,
  milesToKm,
  nextOpenDate,
  utf8Decode
};
